/**
 * @desc 角色信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.RoleIDParameter): Promise<BaseResponse<defs.ResultBean<defs.SysRoleEntityObject>>> {
  return fetch({
    url: config.API_HOST + '/auth/role/info',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
